<template>
  <main id="main">
    <div class="header_page">
      <p id="title_header_page">پرسش و پاسخ های درسی</p>
      <img id="arrow_back_page" src="@/assets/imgs/back.svg" alt="" @click="$router.go(-1)">
    </div>

    <div class="p-3">
      <div v-if="loading" class="text-center mt-5">
        <p>در حال دریافت اطلاعات...</p>
      </div>

      <div v-else>
        <div v-if="questions.length === 0" class="text-center mt-5 text_color_gray">
          سوالی ثبت نکرده‌اید.
        </div>
        <div v-else>
          <div v-for="(item, index) in questions" :key="index" class="bg_white rounded-4 p-3 mb-3 shadow_box">
            <div class="d-flex justify-content-start mb-3">
              <p class="bold">{{ item.lesson_title }} - {{ item.content_title }}</p>
            </div>
            
            <div class="bg_gray_light rounded-3 p-3 mb-3">
              <div class="d-flex align-items-center gap-1 mb-2">
                <p class="bold font_normal">سوال :</p>
                <p class="font_normal text_color_gray">{{ item.question }}</p>
              </div>
            </div>

            <div class="bg_gray_light rounded-3 p-3">
              <div class="d-flex align-items-center gap-1 mb-2">
                <p class="bold font_normal">جواب استاد:</p>
                <p class="font_normal text_color_gray">{{ item.teachers_answer || 'جوابی درج نشده' }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import apiClient, { createFormData } from '@/services/api'

export default {
  name: 'UserQuestionsView',
  data() {
    return {
      questions: [],
      loading: false
    }
  },
  mounted() {
    this.fetchQuestions()
  },
  methods: {
    async fetchQuestions() {
      this.loading = true
      try {
        const userId = localStorage.getItem('user_id')
        const formData = createFormData({
          user_id: userId
        })

        const response = await apiClient.post('/show_questions_answers', formData)

        if (response.data.status === 'ok' && response.data.data) {
          this.questions = response.data.data
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.bg_gray_light {
  background-color: #F6F8FA;
}
.font_normal {
  font-size: 1rem;
}
</style>